import { Directive, ElementRef, HostListener, OnInit, Output, EventEmitter } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[appInputTelephone]',
  providers: [NgModel]
})
export class InputTelephoneDirective implements OnInit {

  constructor(private el: ElementRef, private ngModel: NgModel) { }

  cursorPos: number;
  previousKey: any;

  @Output() newPhone: EventEmitter<any> = new EventEmitter();
  /**
   * Emits the numeric phone value ie. 1234567890
   * Sets the input value to the phone format ie. (123) 456-7890
   * Sets the inputs cursor to the correct locaiton
   */
  filterPhone = function () {
    let value = this.el.nativeElement.value.replace(/[^0-9]/g, '');

    this.el.nativeElement.value = this.getPhone(value);

    // emit the change to the phone number
    this.newPhone.emit(this.getPhone(value).replace(/[^0-9]/g, ''));

    // put the cursor where it belongs.
    this.setCursorLocation();
  };

  ngOnInit() {
    // Binds the ngmodel value to the filterPhone funciton.
    this.ngModel.valueChanges
      .subscribe(
        value => {
          this.filterPhone();
        }
      );
  }

  /**
   * Allows for the copy pasting of phone numbers
   * @param event The keydown event
   */
  @HostListener('keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    const key = event.key;

    this.previousKey = key;
    this.cursorPos = this.el.nativeElement.selectionStart;

    // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
    // This lets us support copy and paste too
    switch (key) {
      case 'Meta':
      case 'Shift':
      case 'Control':
      case 'Alt':
      case 'ArrowUp':
      case 'ArrowDown':
      case 'ArrowLeft':
      case 'ArrowRight':
      case 'Up':
      case 'Down':
      case 'Left':
      case 'Right':
        return;
    }
  }

  /**
   * Handles the logic for setting the cursor in the phone input
   */
  setCursorLocation() {
    if (Number(this.previousKey) >= 0 && Number(this.previousKey) <= 9) {
      this.setCursor(this.getCursorOffset(this.cursorPos));
    } else if (this.previousKey === 'Backspace') {// if it is the backspace key
      this.setCursor(this.getReverseCursorOffset(this.cursorPos + 1));
    } else {
      this.setCursor(this.cursorPos);
    }
  }

  /**
   * Sets the cursor to the specified locaiton in the the input.
   * @param location The location to set the cursor
   */
  private setCursor(location: number): void {
    this.el.nativeElement.selectionEnd = location;
    this.el.nativeElement.selectionStart = location;
  }

  /**
   * Returns the appropriate offset of the cursor position for our fomatting of phone numbers
   * IE: (123) 456|
   * the next key hit should go at position 11 (after the '-') instead of 10.
   * @param location the current location of the cursor
   */
  private getCursorOffset(location: number): number {
    if (location === 0) {
      return 2;
    } else if (location === 4 || location === 5) {
      return 7;
    } else if (location === 9) {
      return 11;
    }
    return location + 1;
  }

  /**
 * Returns the appropriate offset of the cursor position for our fomatting of phone numbers in reverse
 * IE: (123) 4|
 * the next key hit should go at position 4 (before the ')') instead of 6.
 * @param location the current location of the cursor
 */
  private getReverseCursorOffset(location: number): number {
    if (location === 7 || location === 6) {
      return 4;
    } else if (location === 11) {
      return 9;
    }
    return location - 1;
  }

  /**
   * Pulls a formatted phone number from a string of text.
   * @param tel The text to pull the phone number from
   */
  private getPhone(tel: string): string {
    if (!tel) { return ''; }

    const value = tel.toString().trim().replace(/^\+/, '');

    if (value.match(/[^0-9]/)) {
      return tel;
    }

    let country, city, number;

    switch (value.length) {
      case 1:
      case 2:
      case 3:
        city = value;
        break;

      default:
        city = value.slice(0, 3);
        number = value.slice(3);
    }


    if (number) {
      if (number.length > 3) {
        number = number.slice(0, 3) + '-' + number.slice(3, 7);
      } else {
        number = number;
      }

      return ('(' + city + ') ' + number).trim();
    } else {
      return '(' + city;
    }
  }
}
